import React from 'react';
import { FiFileText } from 'react-icons/fi';

// Fonte única de verdade para os metadados dos formulários.
// Reutilizada por FormSelection, AdminForms e pelo guard de acesso por URL.
export const FORMS = [
  {
    id: 'desenvolvimento-produtivo',
    title: 'Desenvolvimento Produtivo',
    description:
      'Formulário para coleta de dados sobre desenvolvimento produtivo na região da RIDE-DF.',
    icon: <FiFileText className="h-8 w-8 text-primary-500" />,
    path: '/forms/desenvolvimento-produtivo',
  },
  {
    id: 'infraestrutura-economica-urbana',
    title: 'Infraestrutura Econômica e Urbana',
    description:
      'Formulário para coleta de dados sobre infraestrutura econômica e urbana na região da RIDE-DF.',
    icon: <FiFileText className="h-8 w-8 text-secondary-500" />,
    path: '/forms/infraestrutura-economica-urbana',
  },
  {
    id: 'diagnostico-municipal',
    title: 'Diagnóstico Municipal',
    description:
      'Formulário para coleta de dados do diagnóstico municipal da RIDE-DF.',
    icon: <FiFileText className="h-8 w-8 text-green-500" />,
    path: '/forms/diagnostico-municipal',
  },
];

// Mapa rápido id -> metadados
export const FORMS_BY_ID = FORMS.reduce((acc, form) => {
  acc[form.id] = form;
  return acc;
}, {});

// Lista de IDs válidos (usada para validação no backend)
export const VALID_FORM_IDS = FORMS.map((f) => f.id);
